import React from 'react';
// import Header from '../../../../../../../Header/Header';
// import Navigationbar from '../../../../Navigationbar/Navigationbar';
import CSCEConfigAdminScreen from './Components/CSCEConfigAdminScreen/CSCEConfigAdminScreen'
import Header from '../../../../../Header/Header';
import Navigationbar from '../../../../../Navigationbar/Navigationbar';

const CSCEConfigAdmin = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <CSCEConfigAdminScreen className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default CSCEConfigAdmin